var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMedication(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 46,
    viewBox: "0 0 47 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 47,
    height: 46,
    rx: 10,
    fill: "#6D5FF2",
    fillOpacity: 0.14
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1898_9353)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.795 28.2051L32.5145 25.4856C33.3117 24.6997 33.9456 23.7639 34.3796 22.732C34.8135 21.7 35.039 20.5924 35.043 19.473C35.047 18.3535 34.8295 17.2444 34.403 16.2093C33.9764 15.1743 33.3493 14.234 32.5577 13.4424C31.7661 12.6508 30.8258 12.0237 29.7908 11.5971C28.7557 11.1706 27.6466 10.9531 26.5271 10.9571C25.4077 10.9611 24.3001 11.1866 23.2681 11.6205C22.2362 12.0545 21.3004 12.6884 20.5145 13.4856L17.795 16.2051L29.795 28.2051ZM28.205 29.7951L16.205 17.7951L13.4855 20.5146C12.6883 21.3005 12.0544 22.2363 11.6204 23.2683C11.1865 24.3002 10.961 25.4078 10.957 26.5272C10.953 27.6467 11.1705 28.7558 11.597 29.7909C12.0236 30.8259 12.6507 31.7663 13.4423 32.5578C14.2338 33.3494 15.1742 33.9765 16.2092 34.4031C17.2442 34.8296 18.3534 35.0471 19.4729 35.0431C20.5923 35.0391 21.6999 34.8136 22.7318 34.3797C23.7638 33.9457 24.6996 33.3118 25.4855 32.5146L28.205 29.7951Z",
    fill: "#6D5FF2"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1898_9353"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(11 11)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedication);
export default __webpack_public_path__ + "static/media/medication.aa7551b2c692ff4b87b7db3722d34411.svg";
export { ForwardRef as ReactComponent };